import React from 'react';
import { Link } from 'react-router-dom';
import { ReportYear } from '~/components/Nav/ReportYear';
import { AuthContext, AuthContextType } from '~/services/AuthContext';
import { ReminderContext, ServicesContext, initialReminderFilters } from '~/services';
import { TimelyActionCounter } from '~/components/Reminders';
import { mapValueArray } from '~/util';
import { ReminderContextType } from '~/services/ReminderContext';
import { Dropdown } from './Dropdown';
import { EprgNavLink } from './EprgNavLink';

// Type assertion for TypeScript 5.x compatibility with react-router-dom v5
const LinkComponent = Link as any;

export function Nav() {
    const { authenticated } = React.useContext(AuthContext) as AuthContextType;
    const { setFilterValues, resetSort, clinicList, pcpList } = React.useContext(
        ReminderContext
    ) as ReminderContextType;
    const context = React.useContext(ServicesContext);
    const timelyActionCounterEnabled = context.user.hasFeatureToggle('in_app_counts');

    return (
        <nav className="navbar navbar-expand navbar-dark shadow-sm">
            <div className="container-fluid">
                <LinkComponent to={authenticated ? '/dashboard' : '/'} className="navbar-brand">
                    <span aria-label="Leading Reach Zephyr" role="heading" aria-level={1} />
                    <img src="/lr-zephyr-reverse.png" alt="Leading Reach Zephyr" />
                </LinkComponent>
                {authenticated && <ReportYear />}
                {authenticated && (
                    <>
                        <span className="navbar-nav ms-auto">
                            <EprgNavLink />
                            <LinkComponent
                                id="nav-timely-actions"
                                to="/reminders"
                                className="nav-link position-relative"
                                title="Timely Actions"
                                onClick={() => {
                                    const notificationFilters =
                                        context.user.getSavedSearchData().savedNotificationOptions
                                            ?.filters;
                                    resetSort();
                                    setFilterValues({
                                        ...initialReminderFilters,
                                        createdByType: 'system',
                                        viewStatus: ['open'],
                                        clinic:
                                            notificationFilters?.clinic && clinicList
                                                ? mapValueArray(
                                                      notificationFilters?.clinic,
                                                      clinicList
                                                  )
                                                : [],
                                        PCP:
                                            notificationFilters?.pcp && pcpList
                                                ? mapValueArray(notificationFilters?.pcp, pcpList)
                                                : [],
                                    });
                                }}
                            >
                                <i className="fa-regular fa-clock" />
                                {timelyActionCounterEnabled && <TimelyActionCounter />}
                            </LinkComponent>
                            <LinkComponent
                                id="nav-reminders"
                                to="/reminders"
                                className="nav-link"
                                title="Reminders"
                                onClick={() => {
                                    resetSort();
                                    setFilterValues({
                                        ...initialReminderFilters,
                                        createdByType: 'user',
                                        viewStatus: ['open'],
                                    });
                                }}
                            >
                                <i className="fa-solid fa-bell" />
                            </LinkComponent>
                        </span>
                        <ul className="navbar-nav">
                            <Dropdown />
                        </ul>
                    </>
                )}
            </div>
        </nav>
    );
}
